import { OrlandoInvitee } from "../rpc/InviteeModel";

export function vaccinationDateIsValid(invitee?: OrlandoInvitee): boolean {
  return !!invitee?.vaccinationDate || !!invitee?.isIneligibleForVaccine;
}
